import { render } from "./LichensHeader.vue?vue&type=template&id=2bbb417d"
import script from "./LichensHeader.vue?vue&type=script&lang=js"
export * from "./LichensHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__